import React from 'react'
import "./color.css"

function GreenE() {
    var x = localStorage.getItem("percentage energy")
    return (
        <div className = "green__background">
            {x == "NaN" ? "null": x} %
        </div>
    )
}

export default GreenE
